/// <reference types="@angular/localize" />

/*!

=========================================================
* Argon Dashboard PRO Angular - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-angular
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import { ApplicationRef, enableProdMode, Inject } from "@angular/core";
import { enableDebugTools } from "@angular/platform-browser";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/markdown/markdown';
import * as Sentry from "@sentry/angular";
import Clarity from "@microsoft/clarity";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { registerLicense } from "@syncfusion/ej2-base";

registerLicense('Ngo9BigBOggjHTQxAR8/V1NMaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWX1fcXRcRWlZUENxVkA=');

if (environment.production) {
  enableProdMode();
}

const enabledSentry = environment.ambiente !== 'prod' && environment.ambiente !== 'local' && window.location.hostname !== 'localhost';

if (enabledSentry) {
  console.log('Enabling Sentry');

  Sentry.init({
    dsn: "https://cfaa3a0ca5a70bbe40a9f3f63b021c29@o313141.ingest.us.sentry.io/4509605138989056",
    release: environment.ambiente,
    environment: environment.ambiente,
    integrations: [],
    ignoreErrors: [
      '<unknown>',
      '<unlabeled event>',
      "Cannot read properties of undefined (reading 'emit')",
      "Permissions check failed",
      "Cannot read properties of null (reading 'removeChild')",
      "this.emitter is undefined",
      "Essa sessão foi desconectada por uma nova sessão!",
      "Handled unknown error",
      "Por favor, faça novamente o login para continuar",
      "Não foi possível abrir a sessão pois o dispositivo está offline!",
      "Uncaught (in promise): [object Undefined]",
      "Query execution was interrupted, maximum statement execution time exceeded",
      "Não possui acesso remoto",
      "Http failure response for /assets/i18n/pt.json: 0 Unknown Error", //é causado por pós atualização + cache do navegador com arquivos antigos
      "ExpressionChangedAfterItHasBeenCheckedError",
      "Já existe um chat aberto com este número com outro operador, por favor finalizar antes!",
      "getaddrinfo ENOTFOUND mysql.milvus.company",
      "Bad Gateway",
      "Http failure during parsing",
      "Uncaught (in promise): [object Number]"
    ], //filtrando alguns erros especificos
    beforeSend(event, hint) {
      const message = event.message || event.exception?.values?.[0]?.value || '';
      const errorType = event.exception?.values?.[0]?.type || '';
      const shouldIgnore =
        errorType.includes('<unknown>') ||
        errorType.includes('<unlabeled event>') ||
        message.includes("Cannot read properties of undefined (reading 'emit')") ||
        message.includes('Permissions check failed') ||
        message.includes("Cannot read properties of null (reading 'removeChild')") ||
        message.includes('this.emitter is undefined') ||
        message.includes("Cannot read properties of undefined (reading 'indexOf')") ||
        errorType.includes("Object.ie") ||
        message.includes("Request failed with status code 500") ||
        message.includes('Object captured as exception with keys: error, headers, message, name, ok') ||
        message.includes('Uncaught (in promise): [object Undefined]')
      return shouldIgnore ? null : event;
    }
  });
}

// Clarity mede o comportamento real de uso (ex.: tempo em tela) e não deve rodar em ambiente local
const enabledClarity = environment.ambiente !== 'local' && window.location.hostname !== 'localhost';

if (enabledClarity) {
  Clarity.init('ymf3t8i671');
}

// Carrega bootstrap com fallback
platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    ngZoneEventCoalescing: true
  })
  .then(module => {
    window.__appLoaded?.();

    enableDebugTools(
      module.injector.get(ApplicationRef).components[0]
    );
  })
  .catch(error => {
    window.__showAppRecovery?.(
      'ANGULAR_BOOTSTRAP_ERROR',
      error instanceof Error ? error.message : error
    );

    console.error(error);
  });